module.exports = __webpack_public_path__ + "static/media/MongoDB-Logo.1a328de2.svg";